import { createSlice } from "@reduxjs/toolkit";
import { businessReducers } from "./reducers";
import {
  AccessControlInitialState,
  BusinessConfigState,
  BillingSettingsInitialState,
  BusinessDetailsInitialState,
  DispatchSettingsInitialState,
  DisplayOptionsInitialState,
  EmailNotificationsInitialState,
  SMSVoiceNotificationsInitialState,
  WaitingTimesInitialState,
  WebsiteDetailsInitialState,
} from "./types";

const initialState: BusinessConfigState = {
  businessDetails: BusinessDetailsInitialState,
  websiteDetails: WebsiteDetailsInitialState,
  emailNotifications: EmailNotificationsInitialState,
  smsVoiceNotifications: SMSVoiceNotificationsInitialState,
  billingSettings: BillingSettingsInitialState,
  accessControl: AccessControlInitialState,
  dispatchSettings: DispatchSettingsInitialState,
  waitingTimes: WaitingTimesInitialState,
  displayOptions: DisplayOptionsInitialState,
};

export const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    businessReducers(builder);
  },
});

export default businessSlice.reducer;
